import type { HTMLAttributes } from 'react';
import './HelpText.css';

export interface HelpTextProps extends HTMLAttributes<HTMLParagraphElement> {
  /** Renders as an error message: swaps colour to `--danger-fg` and sets
   * `role="alert"` so a validation failure is announced, not just recoloured. */
  tone?: 'default' | 'error';
}

/** Field-level helper/error text. Pass the same `id` to the field's
 * `aria-describedby` so assistive tech associates the two — this component
 * does not do that wiring itself, since it doesn't own the field. */
export function HelpText({ tone = 'default', children, className, ...rest }: HelpTextProps) {
  return (
    <p
      className={['dpr-help-text', `dpr-help-text--${tone}`, className].filter(Boolean).join(' ')}
      role={tone === 'error' ? 'alert' : undefined}
      {...rest}
    >
      {children}
    </p>
  );
}
